import React from "react";
import {RouteTabs} from "../common/route-tabs/route.tabs";
import {ComponentPropsFromRoute} from "../../routers/routers";

export const MissingItems: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {

    return (
        <RouteTabs routes={routeChildren!} withoutRootTabPath={true} />
    )
}